<template>
  <!--
    Auth uses `disable-container` so flows can own `ContentWidth`, but
    `PowerUpLayout` still wraps the slot in `power-up-main-frame` (max-width
    1440px, `padding-inline` at ≥1440px) — same gutters as other marketing
    shells (root VitePress site, etc.).
  -->
  <PowerUpLayout
    :logged-in="loggedIn"
    :disable-container="true"
    nav-appearance="marketing"
  >
    <div v-if="route.path === authLinks.registration.path">
      <!-- <AuthPageHeader
        title="Parts Inventory"
        description="Create an account below to view our inventory of affordable turbine parts to keep your plants running at peak efficiency."
      /> -->
      <ContentWidth variant="narrow">
        <h2 class="mb-1">Get Access Today</h2>
        <p class="mb-8">
          Sign up below to get access to our marketplace for gas turbine parts.
          It's free to sign up. All you need is a valid email account.
        </p>
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </ContentWidth>
    </div>

    <div v-else-if="route.path === authLinks.login.path">
      <!-- <AuthPageHeader
        title="Parts Inventory"
        description="Sign in to access our inventory of affordable turbine parts to keep your plants running at peak efficiency."
      /> -->
      <ContentWidth variant="narrow">
        <h2 class="mb-1">Parts Inventory</h2>
        <p class="mb-8">Log in to your account</p>
        <hr class="my-8" />
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </ContentWidth>
    </div>

    <div v-else-if="route.path === authLinks.recovery.path">
      <!-- <AuthPageHeader
        title="Reset Your Password"
        description="Enter your email address and we'll send you a link to reset your password."
      /> -->

      <ContentWidth variant="narrow">
        <h2 class="mb-1">Forgot Password?</h2>
        <p class="mb-8">Enter your email address to reset password</p>
        <hr class="my-8" />
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </ContentWidth>
    </div>

    <div v-else-if="route.path === authLinks.verification.path">
      <ContentWidth variant="narrow">
        <h2 class="mb-1">Verify your email</h2>
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </ContentWidth>
    </div>

    <div v-else>
      <ContentWidth variant="narrow">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </ContentWidth>
    </div>
  </PowerUpLayout>
</template>

<script setup lang="ts">
// import AuthPageHeader from "./components/AuthPageHeader.vue";
import { ContentWidth } from "@saflib/vue/components";
import { PowerUpLayout } from "@vendata/power-up-clients-common";
import { configureAuthApp } from "@saflib/ory-kratos-spa";
import { computed } from "vue";
import { linkToHref, linkToHrefWithHost } from "@saflib/links";
import { accountLinks, appLinks } from "@vendata/power-up-links";
import { useKratosSession } from "@saflib/ory-kratos-sdk";
import { useRoute } from "vue-router";
import { authLinks } from "@saflib/ory-kratos-sdk/links";

const route = useRoute();

const authDomain = () => document.location.host.replace("auth.", "");

configureAuthApp({
  showFlowHeaders: false,
  // MFA is optional for Power-Up; forcing AAL2 after login breaks e2e and
  // redirects new sessions into setup flows unexpectedly.
  requireMfaAfterLogin: false,
  postAuthFallbackHref: () =>
    linkToHref(appLinks.home, { domain: authDomain() }),
  postRegisterOverrideHref: () =>
    linkToHref(appLinks.onboarding, { domain: authDomain() }),
  postRecoverySettingsHref: () => (settingsFlowId: string) =>
    linkToHrefWithHost(accountLinks.password, {
      params: { flow: settingsFlowId },
    }),
});

const sessionQuery = useKratosSession();
const loggedIn = computed(() => !!sessionQuery.data.value);
</script>
